import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {Button} from 'antd'
import {useTimer} from 'dna-common'

import styles from './styles.scss'
import {RESEND} from '@/constants/playwright-ids'

export type Props = {
    text?: string
    onResend: () => void
}

export const ResendButton: React.FC<Props> = observer(({text, onResend}) => {
    const { t } = useTranslation()
    const {start, count, isRunning} = useTimer(60)

    const onClick = async () => {
        await onResend()

        start()
    }

    return (
        <>
            <Button
                type='link'
                className={styles.button}
                onClick={onClick}
                disabled={isRunning}
                data-test-id={RESEND}
            >
                {text || t('ResendButton.text')}
            </Button>
            <Trans
                i18nKey="ResendButton.seconds"
                values={{ count }}
                components={{ b: <b /> }}
            />.
        </>
    )
})
